module.exports = __webpack_public_path__ + "assets/images/Tchibo_Logo_gray.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images/partners/Tchibo_Logo_gray.svg
// module id = 986
// module chunks = 0